var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ResponsiveEnums } from "@yodlee/common-components/dist/types/enumerations";
import { NotificationUtils } from "@yodlee/common-components/dist/utilities";
import { Col, Form, Icon, Row, Spin } from "antd";
import React from "react";
import MediaQuery from "react-responsive";
import { extractInlineImages } from "../../components/rich-text-editor";
import { FormFieldConfigs } from "../../configurations";
import { DataUtils } from "../../utilities";
import RightView from "./right-view";
var UpdateGlobalNotification = /** @class */ (function (_super) {
    __extends(UpdateGlobalNotification, _super);
    function UpdateGlobalNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isLoading: false,
            onFormUpdated: false
        };
        _this.componentDidUpdate = function (prevProps, prevState) {
            var onFormUpdate = _this.props.onFormUpdate;
            var isFieldsTouched = _this.props.form.isFieldsTouched;
            var onFormUpdated = _this.state.onFormUpdated;
            var oldOnFormUpdated = prevState.onFormUpdated;
            if (onFormUpdate && isFieldsTouched() && !onFormUpdated && !oldOnFormUpdated) {
                _this.setState({
                    onFormUpdated: true
                }, function () {
                    onFormUpdate();
                });
            }
        };
        _this.componentDidMount = function () {
            var _a = _this.props, authentication = _a.authentication, globalNotification = _a.globalNotification;
            DataUtils.systemConfig(authentication).get().then(function (onload) {
                _this.setState({ onload: onload });
            });
            if (globalNotification.id) {
                DataUtils.globalNotifications(authentication).getOne(globalNotification.id).then(function (globalNotification) {
                    _this.setState({ globalNotification: globalNotification });
                });
            }
        };
        _this.onSubmit = function (e, isPublish) {
            if (isPublish === void 0) { isPublish = true; }
            var validateFieldsAndScroll = _this.props.form.validateFieldsAndScroll;
            var globalNotification = _this.state.globalNotification;
            var _a = _this.props, authentication = _a.authentication, onUpdate = _a.onUpdate;
            e.preventDefault();
            e.stopPropagation();
            var updateGlobalNotification = function (values) {
                _this.setState({
                    isLoading: true
                });
                var newGlobalNotification = __assign({}, values);
                newGlobalNotification.isPublish = isPublish;
                newGlobalNotification.fromEmail = newGlobalNotification.from;
                newGlobalNotification.includeCsrs = newGlobalNotification.includeCSRs || false;
                var descriptionRichText = newGlobalNotification.description || '';
                var descriptionRawHtml = newGlobalNotification.descriptionRawHtml || '';
                var inlineImageFiles = [];
                if (descriptionRawHtml) {
                    newGlobalNotification.description = "<div id=\"rawHtml\">".concat(descriptionRawHtml, "</div>");
                }
                else if (descriptionRichText) {
                    var imageResult = extractInlineImages(descriptionRichText);
                    newGlobalNotification.description = "<div id=\"richText\">".concat(imageResult.html, "</div>");
                    inlineImageFiles = imageResult.files;
                }
                else {
                    newGlobalNotification.description = '';
                }
                delete newGlobalNotification.descriptionRawHtml;
                if (newGlobalNotification.additionalEmails) {
                    var emails = newGlobalNotification.additionalEmails.trim()
                        ? newGlobalNotification.additionalEmails.split(",").map(function (email) { return email.trim(); }).filter(function (email) { return email.length > 0; })
                        : [];
                    newGlobalNotification.additionalEmails = emails;
                }
                else {
                    newGlobalNotification.additionalEmails = [];
                }
                if (!newGlobalNotification.brands) {
                    newGlobalNotification.brands = [];
                }
                if (newGlobalNotification.selectedBrandInfos && newGlobalNotification.bcc) {
                    newGlobalNotification.selectedBrandInfos
                        .filter(function (brandInfo) { return newGlobalNotification.bcc.includes(brandInfo.index); })
                        .map(function (brandInfo) { return ({ id: brandInfo.id, name: brandInfo.name }); })
                        .forEach(function (brand) {
                        if (!newGlobalNotification.brands.find(function (item) { return item.id === brand.id; })) {
                            newGlobalNotification.brands.push(brand);
                        }
                    });
                }
                delete newGlobalNotification.selectedBrandInfos;
                delete newGlobalNotification.from;
                delete newGlobalNotification.bcc;
                delete newGlobalNotification.includeCSRs;
                if (newGlobalNotification.reviewedBy) {
                    newGlobalNotification.reviewedBy = JSON.parse(newGlobalNotification.reviewedBy);
                }
                var formData = new FormData();
                inlineImageFiles.forEach(function (file) {
                    formData.append("inlineAttachments", file);
                });
                if (newGlobalNotification.inlineAttachments) {
                    newGlobalNotification.inlineAttachments.forEach(function (file) {
                        formData.append("inlineAttachments", file.originFileObj || file);
                    });
                    delete newGlobalNotification.inlineAttachments;
                }
                if (newGlobalNotification.bccAttachmentFiles) {
                    newGlobalNotification.bccAttachmentFiles.forEach(function (file) {
                        formData.append("emailAttachment", file.originFileObj || file);
                    });
                    delete newGlobalNotification.bccAttachmentFiles;
                }
                var globalNotificationRequestBlob = new Blob([JSON.stringify(newGlobalNotification)], {
                    type: 'application/json'
                });
                formData.append("globalNotificationRequest", globalNotificationRequestBlob);
                DataUtils.globalNotifications(authentication).updateOne(globalNotification === null || globalNotification === void 0 ? void 0 : globalNotification.id, formData).then(function (updatedGlobalNotification) {
                    var _a;
                    _this.setState({ globalNotification: updatedGlobalNotification });
                    onUpdate && onUpdate(updatedGlobalNotification);
                    var setFieldsValue = _this.props.form.setFieldsValue;
                    var descriptionRichText = '';
                    var descriptionRawHtml = '';
                    var description = updatedGlobalNotification.description || '';
                    if (description) {
                        var richTextMatch = description.match(/<div\s+id=["']richText["'][^>]*>([\s\S]*?)<\/div>/i);
                        var rawHtmlMatch = description.match(/<div\s+id=["']rawHtml["'][^>]*>([\s\S]*?)<\/div>/i);
                        if (richTextMatch) {
                            descriptionRichText = richTextMatch[1];
                        }
                        else if (rawHtmlMatch) {
                            descriptionRawHtml = rawHtmlMatch[1];
                        }
                        else {
                            descriptionRichText = description;
                        }
                    }
                    setFieldsValue((_a = {},
                        _a[FormFieldConfigs.SUBJECT.key] = updatedGlobalNotification.title || "",
                        _a[FormFieldConfigs.DESCRIPTION_RICH_TEXT.key] = descriptionRichText,
                        _a["descriptionRawHtml"] = descriptionRawHtml,
                        _a));
                }).finally(function () {
                    _this.setState({
                        isLoading: false,
                        onFormUpdated: false
                    });
                });
            };
            validateFieldsAndScroll(function (err, values) {
                console.debug('Received values of globalNotificationForm: ', values, err);
                if (!err && (globalNotification === null || globalNotification === void 0 ? void 0 : globalNotification.id)) {
                    if (isPublish ? values.reviewedBy : true) {
                        updateGlobalNotification(values);
                    }
                    else {
                        NotificationUtils.warning("Reviewed by is missing", "Please provide reviewed by to publish");
                    }
                }
            });
        };
        _this.render = function () {
            var _a = _this.state, onload = _a.onload, globalNotification = _a.globalNotification, isLoading = _a.isLoading;
            return (onload && globalNotification ?
                React.createElement(MediaQuery, { minWidth: ResponsiveEnums.SCREEN_SIZE.MD, minDeviceWidth: ResponsiveEnums.SCREEN_SIZE.MD }, function (matches) {
                    return React.createElement(Form, { onSubmit: _this.onSubmit, colon: false, layout: "horizontal" },
                        React.createElement(Row, { type: "flex", style: { width: '100%' } },
                            React.createElement(Col, { xs: 24, sm: 24, md: 24, lg: 24, xl: 24, xxl: 24 },
                                React.createElement(RightView, { form: _this.props.form, onload: onload, globalNotification: globalNotification, isLoading: isLoading, authentication: _this.props.authentication, onSubmit: function (e, isPublish) { return _this.onSubmit(e, isPublish); } }))));
                }) :
                React.createElement(Row, { type: "flex", style: { height: "80vh" }, justify: "center", align: "middle" },
                    React.createElement(Col, null,
                        React.createElement(Spin, { size: "large", indicator: React.createElement(Icon, { type: "loading" }) }))));
        };
        return _this;
    }
    return UpdateGlobalNotification;
}(React.Component));
export default Form.create({ name: 'update-global-notification' })(UpdateGlobalNotification);
//# sourceMappingURL=index.js.map